/**
 * Keys identifying non-default landing-page variants.
 *
 * Each key maps 1:1 to:
 * - an incoming `utm_campaign` query value (ad campaigns are tagged with it),
 * - a prerendered variant file at `/{locale}/__lp/{key}.html`,
 * - a content entry in the patient-app landing variant registry.
 *
 * Keys MUST be lowercase: S3 object keys are lowercased on upload and CloudFront lowercases the request
 * URI, so the viewer-request rewrite and the prerendered filename only line up for lowercase keys.
 *
 * This module is pure (no Vue/Node runtime) so it can be bundled into the CloudFront viewer-request
 * function. The default landing has no key — see {@link resolveLandingVariant}.
 */
export const LANDING_VARIANT_KEYS = ['glp1'];
//# sourceMappingURL=landingVariantKeys.js.map